// THIS IS A GENERATED FILE
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// Generated on 2025-03-04T08:33:11+00:00

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Color: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Locale: { input: any; output: any; }
  OrderNumber: { input: any; output: any; }
  Polyline: { input: any; output: any; }
  Token: { input: any; output: any; }
  Url: { input: any; output: any; }
};

export type Activity = {
  __typename?: 'Activity';
  averageCadence?: Maybe<Scalars['Float']['output']>;
  averageSpeed?: Maybe<Scalars['Float']['output']>;
  averageTemp?: Maybe<Scalars['Float']['output']>;
  averageWatts?: Maybe<Scalars['Float']['output']>;
  calories?: Maybe<Scalars['Float']['output']>;
  distance?: Maybe<Scalars['Int']['output']>;
  elapsedTime?: Maybe<Scalars['Int']['output']>;
  elevationHigh?: Maybe<Scalars['Int']['output']>;
  elevationLow?: Maybe<Scalars['Int']['output']>;
  endLatlng?: Maybe<LatLng>;
  /** A reference to the FIT file this activity has been extracted from. */
  file?: Maybe<File>;
  gear?: Maybe<Gear>;
  id: Scalars['ID']['output'];
  kilojoules?: Maybe<Scalars['Float']['output']>;
  map?: Maybe<Map>;
  maxSpeed?: Maybe<Scalars['Float']['output']>;
  maxWatts?: Maybe<Scalars['Int']['output']>;
  movingTime?: Maybe<Scalars['Int']['output']>;
  startDate: Scalars['ISO8601DateTime']['output'];
  startLatlng?: Maybe<LatLng>;
  stream?: Maybe<Stream>;
  streams: Array<Stream>;
  totalElevationGain?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<ActivityType>;
};


export type ActivityStreamArgs = {
  transforms?: InputMaybe<Array<StreamTransformType>>;
  type: StreamType;
};

export enum ActivityType {
  /** Alpine Ski */
  AlpineSki = 'ALPINE_SKI',
  /** Backcountry Ski */
  BackcountrySki = 'BACKCOUNTRY_SKI',
  /** Canoeing */
  Canoeing = 'CANOEING',
  /** Crossfit */
  Crossfit = 'CROSSFIT',
  /** Elliptical */
  Elliptical = 'ELLIPTICAL',
  /** EBikeRide */
  EBikeRide = 'E_BIKE_RIDE',
  /** Golf */
  Golf = 'GOLF',
  /** Hike */
  Hike = 'HIKE',
  /** IceSkate */
  IceSkate = 'ICE_SKATE',
  /** InlineSkate */
  InlineSkate = 'INLINE_SKATE',
  /** Kayaking */
  Kayaking = 'KAYAKING',
  /** Kitesurf */
  Kitesurf = 'KITESURF',
  /** NordicSki */
  NordicSki = 'NORDIC_SKI',
  /** Ride */
  Ride = 'RIDE',
  /** RockClimbing */
  RockClimbing = 'ROCK_CLIMBING',
  /** RollerSki */
  RollerSki = 'ROLLER_SKI',
  /** Rowing */
  Rowing = 'ROWING',
  /** Run */
  Run = 'RUN',
  /** Snowboard */
  Snowboard = 'SNOWBOARD',
  /** Snowshoe */
  Snowshoe = 'SNOWSHOE',
  /** StairStepper */
  StairStepper = 'STAIR_STEPPER',
  /** StandUpPaddling */
  StandUpPaddling = 'STAND_UP_PADDLING',
  /** Surfing */
  Surfing = 'SURFING',
  /** Swim */
  Swim = 'SWIM',
  /** VirtualRide */
  VirtualRide = 'VIRTUAL_RIDE',
  /** VirtualRun */
  VirtualRun = 'VIRTUAL_RUN',
  /** Walk */
  Walk = 'WALK',
  /** WeightTraining */
  WeightTraining = 'WEIGHT_TRAINING',
  /** Windsurf */
  Windsurf = 'WINDSURF',
  /** Workout */
  Workout = 'WORKOUT',
  /** Yoga */
  Yoga = 'YOGA'
}

/** Autogenerated return type of AddCartItem. */
export type AddCartItemPayload = {
  __typename?: 'AddCartItemPayload';
  /** The updated cart. A list of inventory items. */
  cart: Cart;
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
  /** The currently authenticated user. */
  me: User;
};

export type Aggregate = {
  __typename?: 'Aggregate';
  /**
   * Get stats for a specific field. Fields that can
   *           be analyzed are defined by the analytics field enum.
   */
  field: FieldValue;
  /** Same as field(…) but group results by activity type. */
  fieldAndGroup: Array<GroupValue>;
  /**
   * Period based stats for the current time range.
   *           It allows you to get analytics values for a given field, aggregated
   *           by a given interval. It also provides empty values for periods where no
   *           activity has been tracked.
   */
  series: Array<Interval>;
  /**
   * A summary over the current activity set. You can
   *           use this to provide simple stats.
   */
  summary: SummaryValue;
};


export type AggregateFieldArgs = {
  field: Field;
  filter?: InputMaybe<Array<Filter>>;
};


export type AggregateFieldAndGroupArgs = {
  field: Field;
  filter?: InputMaybe<Array<Filter>>;
};


export type AggregateSeriesArgs = {
  field: Field;
  interval: TimePeriod;
};


export type AggregateSummaryArgs = {
  filter?: InputMaybe<Array<Filter>>;
};

export type Beta = {
  __typename?: 'Beta';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  state: BetaState;
};

export enum BetaState {
  /** Off */
  Off = 'OFF',
  /** On */
  On = 'ON'
}

export type Cart = {
  __typename?: 'Cart';
  amount: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  items: Array<CartItem>;
};

export type CartItem = {
  __typename?: 'CartItem';
  id: Scalars['ID']['output'];
  product: InventoryItem;
  quantity: Scalars['Int']['output'];
  /** A reference to the real product item (e.g. Poster) */
  reference?: Maybe<Reference>;
};

/** Autogenerated return type of Checkout. */
export type CheckoutPayload = {
  __typename?: 'CheckoutPayload';
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
  /** The currently authenticated user. */
  me: User;
  /** The order to checkout. */
  order?: Maybe<Order>;
};

/** Autogenerated return type of ClearCart. */
export type ClearCartPayload = {
  __typename?: 'ClearCartPayload';
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
  /** The currently authenticated user. */
  me: User;
};

/** Autogenerated return type of Connect. */
export type ConnectPayload = {
  __typename?: 'ConnectPayload';
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
  /** The currently authenticated user. */
  me: User;
};

/** The contact form payload */
export type ContactInput = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Cost = {
  __typename?: 'Cost';
  complexity: Scalars['Int']['output'];
  depth: Scalars['Int']['output'];
};

/** Autogenerated return type of CreateActivity. */
export type CreateActivityPayload = {
  __typename?: 'CreateActivityPayload';
  /** The created activity. */
  activity?: Maybe<Activity>;
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
  /** The currently authenticated user. */
  me: User;
};

/** Autogenerated return type of CreateNewsletter. */
export type CreateNewsletterPayload = {
  __typename?: 'CreateNewsletterPayload';
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
  /** The currently authenticated user. */
  newsletter: Newsletter;
};

/** Autogenerated return type of CreateReceipts. */
export type CreateReceiptsPayload = {
  __typename?: 'CreateReceiptsPayload';
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
};

export type CreditCard = PaymentDetails & {
  __typename?: 'CreditCard';
  brand: Scalars['String']['output'];
  last4: Scalars['String']['output'];
  type: PaymentType;
};

/** Autogenerated return type of DeleteNewsletter. */
export type DeleteNewsletterPayload = {
  __typename?: 'DeleteNewsletterPayload';
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
};

/** Autogenerated return type of DeletePoster. */
export type DeletePosterPayload = {
  __typename?: 'DeletePosterPayload';
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
  /** The currently authenticated user. */
  me: User;
};

export type Editor = {
  __typename?: 'Editor';
  /** A list of available poster variations. */
  posterVariants: Array<PosterVariant>;
};

/** A user-readable error */
export type Error = {
  __typename?: 'Error';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type Extension = {
  __typename?: 'Extension';
  cost: Cost;
};

export enum Field {
  /** Distance */
  Distance = 'DISTANCE',
  /** Elapsed time */
  ElapsedTime = 'ELAPSED_TIME',
  /** Elevation high */
  ElevationHigh = 'ELEVATION_HIGH',
  /** Elevation low */
  ElevationLow = 'ELEVATION_LOW',
  /** Moving time */
  MovingTime = 'MOVING_TIME',
  /** Total elevation gain */
  TotalElevationGain = 'TOTAL_ELEVATION_GAIN'
}

export type FieldValue = {
  __typename?: 'FieldValue';
  /** The average value for this field. */
  avg: Scalars['Float']['output'];
  /** The max value for this field. */
  max: Scalars['Int']['output'];
  /** The min value for this field. */
  min: Scalars['Int']['output'];
  /** The sum of all values for this field. */
  total: Scalars['Int']['output'];
};

/** A file reference. */
export type File = {
  __typename?: 'File';
  /** The unique file identifier. */
  id: Scalars['ID']['output'];
};

export enum Filter {
  /** Filter empty values from set */
  Empty = 'EMPTY',
  /** No filter */
  None = 'NONE'
}

export type Gear = {
  __typename?: 'Gear';
  brand?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distance: Scalars['Int']['output'];
  frame?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  primary: Scalars['Boolean']['output'];
  type: GearType;
};

export enum GearType {
  /** Bike */
  Bike = 'BIKE',
  /** Shoe */
  Shoe = 'SHOE'
}

export type GroupValue = {
  __typename?: 'GroupValue';
  /** The average value for this field. */
  avg: Scalars['Float']['output'];
  /** Activity type the field has been grouped by. */
  group: ActivityType;
  /** The max value for this field. */
  max: Scalars['Int']['output'];
  /** The min value for this field. */
  min: Scalars['Int']['output'];
  /** The sum of all values for this field. */
  total: Scalars['Int']['output'];
};

export type Image = {
  __typename?: 'Image';
  url: Scalars['Url']['output'];
};

export enum ImageTransform {
  /** Original */
  Original = 'ORIGINAL',
  /** thumbnail */
  Thumbnail = 'THUMBNAIL',
  /** thumbnail@2x */
  Thumbnail_2X = 'THUMBNAIL_2X'
}

export type Import = {
  __typename?: 'Import';
  state: ImportState;
};

/** Autogenerated return type of ImportAthlete. */
export type ImportAthletePayload = {
  __typename?: 'ImportAthletePayload';
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
};

export enum ImportState {
  /** Import is complete */
  Complete = 'COMPLETE',
  /** Not started, no import state */
  None = 'NONE',
  /** Import is partially done */
  Partial = 'PARTIAL',
  /** Import is in progress */
  Progress = 'PROGRESS'
}

export type Interval = {
  __typename?: 'Interval';
  /** The average value for this field. */
  avg: Scalars['Float']['output'];
  /** Total number of activities for this interval value. */
  count: Scalars['Int']['output'];
  /** The day of this for this interval value. */
  day: Scalars['Int']['output'];
  /** The week of this for this interval value. */
  interval: TimePeriod;
  /** The max value for this field. */
  max: Scalars['Int']['output'];
  /** The min value for this field. */
  min: Scalars['Int']['output'];
  /** The month of this for this interval value. */
  month: Scalars['Int']['output'];
  /** The sum of all values for this field. */
  total: Scalars['Int']['output'];
  /** The week of this for this interval value. */
  week: Scalars['Int']['output'];
  /** The year of this for this interval value. */
  year: Scalars['Int']['output'];
};

export type InventoryItem = {
  __typename?: 'InventoryItem';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  sku: Scalars['String']['output'];
};

export type LatLng = {
  __typename?: 'LatLng';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type Map = {
  __typename?: 'Map';
  polyline?: Maybe<Scalars['Polyline']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Add a product to the cart. */
  addCartItem?: Maybe<AddCartItemPayload>;
  /** Checkout cart. */
  checkout?: Maybe<CheckoutPayload>;
  /** Clear cart. */
  clearCart?: Maybe<ClearCartPayload>;
  /** Connect user with another external account (e.g. Polar, Suunto, …). */
  connect?: Maybe<ConnectPayload>;
  /** Creates a new activity from FIT file. */
  createActivity?: Maybe<CreateActivityPayload>;
  /** Creates a new newsletter. */
  createNewsletter?: Maybe<CreateNewsletterPayload>;
  /** Create all missing receipts. */
  createReceipts?: Maybe<CreateReceiptsPayload>;
  /** Deletes an existing newsletter. */
  deleteNewsletter?: Maybe<DeleteNewsletterPayload>;
  /** Delete poster. */
  deletePoster?: Maybe<DeletePosterPayload>;
  /** Import or reimport an athlete from given provider. */
  importAthlete?: Maybe<ImportAthletePayload>;
  /** Remove a specific product from the cart. */
  removeCartItem?: Maybe<RemoveCartItemPayload>;
  /** If user has a pending email confirmation, resend confirmation email. */
  resendEmailConfirmation?: Maybe<ResendEmailConfirmationPayload>;
  /** Reset preview poster for current user. */
  resetPreview?: Maybe<ResetPreviewPayload>;
  /** Save poster. */
  savePoster?: Maybe<SavePosterPayload>;
  /** Save preview poster for current user. */
  savePreview?: Maybe<SavePreviewPayload>;
  /** Save any changes to user account. */
  saveUser?: Maybe<SaveUserPayload>;
  /** Send an email to Spurtli. */
  sendContactForm?: Maybe<SendContactFormPayload>;
  /** Subscribe to a newsletter. */
  subscribeNewsletter?: Maybe<SubscribeNewsletterPayload>;
  /** Unsubscribe from newsletter. */
  unsubscribeNewsletter?: Maybe<UnsubscribeNewsletterPayload>;
  /** Update quantity of items for a specific product. */
  updateCartItem?: Maybe<UpdateCartItemPayload>;
};


export type MutationAddCartItemArgs = {
  productId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<ReferenceInput>;
};


export type MutationCheckoutArgs = {
  checkout: PaymentInput;
};


export type MutationConnectArgs = {
  code: Scalars['String']['input'];
  provider: ProviderName;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateActivityArgs = {
  fileId: Scalars['ID']['input'];
};


export type MutationCreateNewsletterArgs = {
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteNewsletterArgs = {
  newsletterId: Scalars['ID']['input'];
};


export type MutationDeletePosterArgs = {
  posterId: Scalars['ID']['input'];
};


export type MutationImportAthleteArgs = {
  providerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRemoveCartItemArgs = {
  cartItemId: Scalars['ID']['input'];
};


export type MutationSavePosterArgs = {
  poster: PosterInput;
  posterId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSavePreviewArgs = {
  poster: PosterInput;
};


export type MutationSaveUserArgs = {
  user: UserInput;
};


export type MutationSendContactFormArgs = {
  payload: ContactInput;
};


export type MutationSubscribeNewsletterArgs = {
  email: Scalars['String']['input'];
  newsletterId: Scalars['ID']['input'];
};


export type MutationUnsubscribeNewsletterArgs = {
  newsletterId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpdateCartItemArgs = {
  cartItemId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type Newsletter = {
  __typename?: 'Newsletter';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

/** The connection type for Newsletter. */
export type NewsletterConnection = {
  __typename?: 'NewsletterConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NewsletterEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Newsletter>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NewsletterEdge = {
  __typename?: 'NewsletterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Newsletter>;
};

export type Notification = {
  __typename?: 'Notification';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
  user: User;
};

export type Order = {
  __typename?: 'Order';
  /** The order creation date. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  items: Array<OrderItem>;
  /** The global unique order number */
  number: Scalars['OrderNumber']['output'];
  /** The associated payment object. */
  payment: Payment;
  /** The receipt for this order. */
  receipt: Receipt;
  /** Net sum of all items in this order. */
  sum: Scalars['Int']['output'];
  /** Tax sum of all items in this order. */
  tax: Scalars['Int']['output'];
  /** Total sum of all items in this order. */
  total: Scalars['Int']['output'];
};

/** The connection type for Order. */
export type OrderConnection = {
  __typename?: 'OrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Order>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OrderEdge = {
  __typename?: 'OrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Order>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  id: Scalars['ID']['output'];
  product: InventoryItem;
  quantity: Scalars['Int']['output'];
  /** A reference to the real product item (e.g. Poster) */
  reference?: Maybe<Reference>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Payment = {
  __typename?: 'Payment';
  details: PaymentDetails;
  id: Scalars['ID']['output'];
  state: PaymentState;
};

/** Payment details do include specific details to the selected payment type. */
export type PaymentDetails = {
  type: PaymentType;
};

export type PaymentInput = {
  token: Scalars['Token']['input'];
};

export enum PaymentState {
  /** Payment error */
  Error = 'ERROR',
  /** Payment pending */
  Pending = 'PENDING',
  /** Payment success */
  Success = 'SUCCESS'
}

export enum PaymentType {
  /** Credit card */
  CreditCard = 'CREDIT_CARD'
}

export type Poster = Reference & {
  __typename?: 'Poster';
  activities: Array<Activity>;
  activitiesBlacklist?: Maybe<Scalars['JSON']['output']>;
  activitiesEndDate: Scalars['ISO8601DateTime']['output'];
  activitiesStartDate: Scalars['ISO8601DateTime']['output'];
  activitiesWhitelist?: Maybe<Scalars['JSON']['output']>;
  activityTypes: Array<ActivityType>;
  baseColor: Scalars['Color']['output'];
  highlightColor: Scalars['Color']['output'];
  id: Scalars['ID']['output'];
  /** A single image representation of this poster. It takes a "transform" argument which will default to "ORIGINAL" size. */
  image: Image;
  /** A list of image representations of this poster. It takes a "transforms" argument which requires to be a list of distinct values of type "ImageTransform". */
  images: Array<Image>;
  name: Scalars['String']['output'];
  /** Available option values for this poster. */
  options: PosterOptions;
  variant: PosterVariant;
};


export type PosterImageArgs = {
  transform?: InputMaybe<ImageTransform>;
};


export type PosterImagesArgs = {
  transforms: Array<ImageTransform>;
};

/** The connection type for Poster. */
export type PosterConnection = {
  __typename?: 'PosterConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PosterEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Poster>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PosterEdge = {
  __typename?: 'PosterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Poster>;
};

/** The poster input type contains all modifiable attributes */
export type PosterInput = {
  activitiesBlacklist?: InputMaybe<Scalars['JSON']['input']>;
  activitiesEndDate: Scalars['ISO8601DateTime']['input'];
  activitiesStartDate: Scalars['ISO8601DateTime']['input'];
  activitiesWhitelist?: InputMaybe<Scalars['JSON']['input']>;
  activityTypes: Array<ActivityType>;
  baseColor: Scalars['Color']['input'];
  highlightColor: Scalars['Color']['input'];
  name: Scalars['String']['input'];
  variant: PosterVariant;
};

export type PosterOptions = {
  __typename?: 'PosterOptions';
  /** List of available activity types. */
  activityTypes: Array<ActivityType>;
  /** Available color palette. */
  colors: Array<Scalars['Color']['output']>;
};

export enum PosterVariant {
  /** A grid of dots. The size of the dots represents the relative weekly activity time over the selected period. */
  Dot = 'DOT',
  /** Graph */
  Graph = 'GRAPH',
  /** Shapes */
  Shapes = 'SHAPES',
  /** Spiral */
  Spiral = 'SPIRAL'
}

export type Provider = {
  __typename?: 'Provider';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Provider. */
export type ProviderConnection = {
  __typename?: 'ProviderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProviderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Provider>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProviderEdge = {
  __typename?: 'ProviderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Provider>;
};

export enum ProviderName {
  /** Polar */
  Polar = 'POLAR',
  /** Strava */
  Strava = 'STRAVA'
}

export type Query = {
  __typename?: 'Query';
  /** Get all athletes. */
  athletes: UserConnection;
  /** Beta flags */
  beta: Array<Beta>;
  /**
   * Available editor options that are not defined by
   *         the currently signed in user.
   */
  editor: Editor;
  /** GraphQL extensions */
  extensions: Extension;
  /**
   * The current user is usually the currently
   *         authenticated user.
   */
  me: User;
  /** Get all providers. */
  providers: ProviderConnection;
  /** Global stats for all athletes on Spurtli. */
  stats: Stats;
};


export type QueryAthletesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBetaArgs = {
  names: Array<Scalars['String']['input']>;
};


export type QueryProvidersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Receipt = {
  __typename?: 'Receipt';
  /** Fully qualified and signed URL for a receipt. */
  url: Scalars['Url']['output'];
};

/** The product item is an interface for any real product item (e.g. Poster) plus version */
export type Reference = {
  id: Scalars['ID']['output'];
};

/** A product item is an optional reference to a polymorphic model */
export type ReferenceInput = {
  id: Scalars['ID']['input'];
  type: ReferenceType;
  version?: InputMaybe<Scalars['String']['input']>;
};

export enum ReferenceType {
  /** Poster */
  Poster = 'POSTER'
}

/** Autogenerated return type of RemoveCartItem. */
export type RemoveCartItemPayload = {
  __typename?: 'RemoveCartItemPayload';
  /** The updated cart. A list of inventory items. */
  cart: Cart;
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
  /** The currently authenticated user. */
  me: User;
};

/** Autogenerated return type of ResendEmailConfirmation. */
export type ResendEmailConfirmationPayload = {
  __typename?: 'ResendEmailConfirmationPayload';
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
  /** The currently authenticated user. */
  me: User;
};

/** Autogenerated return type of ResetPreview. */
export type ResetPreviewPayload = {
  __typename?: 'ResetPreviewPayload';
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
  /** The currently authenticated user. */
  me: User;
  /** The preview poster. */
  poster: Poster;
};

/** Autogenerated return type of SavePoster. */
export type SavePosterPayload = {
  __typename?: 'SavePosterPayload';
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
  /** The currently authenticated user. */
  me: User;
  /** The saved poster. */
  poster?: Maybe<Poster>;
};

/** Autogenerated return type of SavePreview. */
export type SavePreviewPayload = {
  __typename?: 'SavePreviewPayload';
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
  /** The currently authenticated user. */
  me: User;
  /** The saved preview poster. */
  poster?: Maybe<Poster>;
};

/** Autogenerated return type of SaveUser. */
export type SaveUserPayload = {
  __typename?: 'SaveUserPayload';
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
  /** The currently authenticated user. */
  me: User;
};

/** Autogenerated return type of SendContactForm. */
export type SendContactFormPayload = {
  __typename?: 'SendContactFormPayload';
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
};

export type Stats = {
  __typename?: 'Stats';
  activityTypes: Array<ActivityType>;
  totalActivities: Scalars['Int']['output'];
  totalCalories: Scalars['Int']['output'];
  totalDistance: Scalars['Int']['output'];
  totalElapsedTime: Scalars['Int']['output'];
  totalElevationGain: Scalars['Int']['output'];
  totalMovingTime: Scalars['Int']['output'];
};

export type Stream = {
  __typename?: 'Stream';
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  type: StreamType;
};

export enum StreamTransformType {
  /** Sample to a max of 50 data points */
  SampleN50 = 'SAMPLE_N50',
  /** Sample to a max of 100 data points */
  SampleN100 = 'SAMPLE_N100',
  /** Sample to 10% of all data points */
  SampleP10 = 'SAMPLE_P10'
}

export enum StreamType {
  /** Altitude */
  Altitude = 'ALTITUDE',
  /** Cadence */
  Cadence = 'CADENCE',
  /** Distance */
  Distance = 'DISTANCE',
  /** Grade Smooth */
  GradeSmooth = 'GRADE_SMOOTH',
  /** Heartrate */
  Heartrate = 'HEARTRATE',
  /** Latitude and Longitude */
  Latlng = 'LATLNG',
  /** Moving */
  Moving = 'MOVING',
  /** Temperature */
  Temp = 'TEMP',
  /** Time */
  Time = 'TIME',
  /** Velocity smooth */
  VelocitySmooth = 'VELOCITY_SMOOTH',
  /** Watts */
  Watts = 'WATTS'
}

/** Autogenerated return type of SubscribeNewsletter. */
export type SubscribeNewsletterPayload = {
  __typename?: 'SubscribeNewsletterPayload';
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
  /** The user who subscribed to the newsletter. */
  user?: Maybe<User>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Notifies about the creation of a set of default posters. */
  defaultPostersCreate: User;
  /** Any update to a user import state. */
  userImport: User;
  /** A user receives a notification. */
  userNotification?: Maybe<Notification>;
};

export type SummaryValue = {
  __typename?: 'SummaryValue';
  /**
   * The total number of activities for the
   *           current selection.
   */
  count: Scalars['Int']['output'];
  /**
   * A list of available activity types for the
   *           current selection.
   */
  types: Array<ActivityType>;
};

export enum TimePeriod {
  /** A relative period of time that matches one day */
  Day = 'DAY',
  /** A relative period of time that matches one month */
  Month = 'MONTH',
  /** A relative period of time that matches one week */
  Week = 'WEEK',
  /** A relative period of time that matches one year */
  Year = 'YEAR'
}

export enum Unit {
  /** Imperial */
  Imperial = 'IMPERIAL',
  /** Metric */
  Metric = 'METRIC'
}

/** Autogenerated return type of UnsubscribeNewsletter. */
export type UnsubscribeNewsletterPayload = {
  __typename?: 'UnsubscribeNewsletterPayload';
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
  /** The currently authenticated user. */
  me: User;
};

/** Autogenerated return type of UpdateCartItem. */
export type UpdateCartItemPayload = {
  __typename?: 'UpdateCartItemPayload';
  /** The updated cart. A list of inventory items. */
  cart: Cart;
  /** A list of errors. An empty list in case no errors occurred. */
  errors: Array<Error>;
  /** The currently authenticated user. */
  me: User;
};

export type User = {
  __typename?: 'User';
  /**
   * A list of years where an athlete has been active
   *         (has at least one activity).
   */
  activeYears: Array<Scalars['Int']['output']>;
  /**
   * A list of user activities. The result set is narrowed
   *         down by a range for activities start date and activity types.
   */
  activities: Array<Activity>;
  /**
   * The formatted full address of this user. Created
   *         out of the provided address details, such as street, city, country, …
   */
  address: Scalars['String']['output'];
  /**
   * Provides a simple aggregation interface to
   *         current user activities. Use the arguments, to narrow down to a set of
   *         specific activities which you wanna aggregate.
   */
  aggregates: Aggregate;
  /** Provide c/o if necessary. */
  careOf?: Maybe<Scalars['String']['output']>;
  /** The shopping cart for this user. */
  cart: Cart;
  /** City. */
  city?: Maybe<Scalars['String']['output']>;
  /** Country. */
  country?: Maybe<Scalars['String']['output']>;
  /**
   * The users email address if available. A user
   *         with no or an invalid email address is considered as incomplete user.
   */
  email?: Maybe<Scalars['String']['output']>;
  /** Whether the users has a pending email confirmation request that has expired. */
  emailConfirmationExpired: Scalars['Boolean']['output'];
  /** Whether the user has a pending email confirmation request. */
  emailConfirmationPending: Scalars['Boolean']['output'];
  /** Whether the users email address is confirmed or not. */
  emailConfirmed: Scalars['Boolean']['output'];
  /** The first name of the user. */
  firstname?: Maybe<Scalars['String']['output']>;
  /**
   * A list of users current gear. List can be
   *         filtered by gear type.
   */
  gear: Array<Gear>;
  /** The user ID. */
  id: Scalars['ID']['output'];
  /**
   * Return the import state for current user. This
   *         is usually used to provide some feedback to the user after signing in.
   */
  import: Import;
  /** The last name of the user. */
  lastname?: Maybe<Scalars['String']['output']>;
  /**
   * The users locale setting. Used to set defaults for
   *         currency, numbers and other i18n dependents.
   */
  locale: Scalars['Locale']['output'];
  /**
   * The full name of the user. Created from firstname
   *         and lastname.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** This users newsletter subscriptions. */
  newsletters: NewsletterConnection;
  /** A paginated list of orders. */
  orders: OrderConnection;
  /** Phone. */
  phone?: Maybe<Scalars['String']['output']>;
  /** Get a poster by ID. */
  poster: Poster;
  /** Get a paginated list of posters. */
  posters: PosterConnection;
  /**
   * Get users preview poster. This poster is a
   *         special kind of the regular poster. It behaves like a regular poster,
   *         you can request all the information as usual but it will be used by the
   *         editor.
   */
  preview: Poster;
  /** State if available. */
  state?: Maybe<Scalars['String']['output']>;
  /** A high level stats report for the current user. */
  stats: Stats;
  /** Street name and house number. */
  street?: Maybe<Scalars['String']['output']>;
  /** The unconfirmed email address of the current user. Only set in case there is a pending confirmation request. */
  unconfirmedEmail?: Maybe<Scalars['String']['output']>;
  /**
   * The users unit setting. Can override the default
   *         derived from users locale.
   */
  units: Unit;
  /** The unique username for this user. */
  username?: Maybe<Scalars['String']['output']>;
  /** Current weight of user. */
  weight?: Maybe<Scalars['Int']['output']>;
  /** ZIP/Postal code. */
  zip?: Maybe<Scalars['String']['output']>;
};


export type UserActivitiesArgs = {
  from: Scalars['ISO8601DateTime']['input'];
  to: Scalars['ISO8601DateTime']['input'];
  types?: InputMaybe<Array<ActivityType>>;
};


export type UserAggregatesArgs = {
  blacklist?: InputMaybe<Scalars['JSON']['input']>;
  from: Scalars['ISO8601DateTime']['input'];
  to: Scalars['ISO8601DateTime']['input'];
  types?: InputMaybe<Array<ActivityType>>;
  whitelist?: InputMaybe<Scalars['JSON']['input']>;
};


export type UserGearArgs = {
  type?: InputMaybe<GearType>;
};


export type UserNewslettersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserPosterArgs = {
  posterId: Scalars['ID']['input'];
};


export type UserPostersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

/** The user input type contains all modifiable attributes */
export type UserInput = {
  careOf?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  units?: InputMaybe<Unit>;
  username?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};
